import { render, staticRenderFns } from "./NoData.vue?vue&type=template&id=25c0bd41&"
import script from "./NoData.vue?vue&type=script&lang=ts&"
export * from "./NoData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports